import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, boxImage } from '../data/salesCopy';
export function FinalCTA() {
  return <section className="bg-brand-brown px-4 py-9 sm:py-12" data-id="element-53" data-mp="3ue897ji3p2sf">
      <div className="mx-auto max-w-2xl text-center" data-id="element-54" data-mp="c70xva6rjfok">
        <h2 className="font-serif text-2xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-55" data-mp="c4oa2gebqb3l">
          Une dernière question
        </h2>
        <span className="mx-auto mt-2 block h-0.5 w-14 bg-brand-gold" data-id="element-56" data-mp="m46o6g7jz2nq" />

        <p className="mt-3 text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-57" data-mp="h656nzprzbed">
          Combien de fois saviez-vous que vous deviez préparer votre prochain
          cours… mais avez quand même passé du temps à chercher des postures, des
          variations et une nouvelle structure ?
        </p>
        <p className="mt-2 text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-58" data-mp="14uwt0agoozj8">
          Vous pouvez continuer à naviguer entre notes, séquences enregistrées et
          ressources dispersées. Ou vous pouvez ouvrir un seul système visuel
          organisé.
        </p>
        <p className="mt-2.5 font-serif text-lg font-bold uppercase tracking-wide text-brand-gold sm:text-2xl" data-id="element-59" data-mp="2h3hn6kmywq49">
          Choisissez l’objectif. Structurez la séance. Adaptez. Enseignez.
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-4 block" data-id="element-60" data-mp="2r1nrf8w8y8ca">
          <img src={boxImage} alt="Coffret YIN YOGA PRO™" className="mx-auto w-full max-w-[220px] sm:max-w-[280px]" data-id="element-61" data-mp="2v3sefos6w6py" />
        </a>

        <h3 className="mt-2 font-serif text-3xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-62" data-mp="30092yk3awn3k">
          🧘 Yin Yoga Pro™
        </h3>
        <p className="mx-auto mt-1.5 max-w-xl text-[12px] font-semibold uppercase leading-snug tracking-wide text-brand-sand" data-id="element-63" data-mp="39sop7tlmrxu9">
          Le système visuel complet pour les professeurs de Yin Yoga
        </p>
        <p className="mt-1 text-[11.5px] font-medium text-white/70" data-id="element-64" data-mp="3iu4u5ltof7r3">
          Postures • Séquences • Création • Adaptations • Thématiques •
          Planification
        </p>

        <p className="mt-3 text-[11px] font-bold uppercase tracking-wide text-brand-gold" data-id="element-65" data-mp="1eps7554fbskr">
          🔥 Obtenez le système complet aujourd’hui
        </p>
        <div className="mt-2 flex justify-center" data-id="element-66" data-mp="1sirm960ankrs">
          <CTAButton href={CHECKOUT_URL} external size="lg" data-id="element-67" data-mp="1npoosmsebr6b">
            🧘 Oui ! Je veux Yin Yoga Pro™
          </CTAButton>
        </div>

        <div className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-white/75" data-id="element-68" data-mp="22d048zrp7vbp">
          <span data-id="element-69" data-mp="2bf9bngro78kv">Accès immédiat • Livraison numérique</span>
          <span data-id="element-70" data-mp="2beq50w7h06m5">🛡️ Garantie satisfait ou remboursé de 7 jours</span>
          <span className="rounded-full bg-white/10 px-2.5 py-1" data-id="element-71" data-mp="27ez6u7fm6o7l">
            🧘 Système complet 6-en-1
          </span>
        </div>
      </div>
    </section>;
}